module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "app"
    }
  }, [_c('router-view')], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-1fbe2fd9"}!./~/vue-loader/lib/selector.js?type=template&index=0!./libs/@db2b/keystone/components/Templates/Layouts/MinimalLayout.vue
// module id = 674
// module chunks = 1